import React, { useReducer } from "react";
import { useDispatch } from "react-redux";
import { setMessageHandler } from "../../../reducers/selectedValues";
import { Box } from "@mui/material";
import { InputText } from "../../uiControls/inputText";
import useHttpRequests from "../../../hooks/useHttpRequests";
import { MessageDisplay } from "../../common/messageDisplay";
import { SaveCancel } from "../../uiControls/saveCancel";
import { StatusControl } from "../../uiControls/statusControl";
import * as utils from "../../common/utils";

const initialFunctionalAreaIsValid = {
  name: "",
  description: "",
};

export const FunctionalAreaUpdate = (props) => {
  const {
    setUpdateOpen,
    functionalAreaEdit,
    setFunctionalAreaEdit,
    functionalAreaAttributes,
  } = props;
  const messageDispatch = useDispatch();
  const { sendRequest: updateFunctionalArea } = useHttpRequests();

  const [functionalAreaDetails, setFunctionalAreaDetails] = useReducer(
    (state, updates) => ({ ...state, ...updates }),
    functionalAreaAttributes
  );

  const [isValid, setIsValid] = useReducer(
    (state, updates) => ({ ...state, ...updates }),
    initialFunctionalAreaIsValid
  );

  const updateFunctionalAreaDetailsValue = (_key, value) => {
    setFunctionalAreaDetails({ [_key]: value });
    if (value) {
      updateErrorMessage([_key], "", "");
    }
  };

  const updateErrorMessage = (_key, header, errMsg) => {
    setIsValid({ [_key]: errMsg + header });
  };

  const onChangeHandler = (e, controlName) => {
    updateFunctionalAreaDetailsValue(
      controlName,
      e.target.type === "checkbox" ? e.target.checked : e.target.value
    );
  };

  const cancelFunctionalAreaHandler = () => {
    messageDispatch(setMessageHandler({ type: null, message: null }));
    setUpdateOpen(false);
    setFunctionalAreaEdit(false);
  };

  const validateFunctionalAreaDetails = () => {
    setIsValid(initialFunctionalAreaIsValid);

    var errorSummary = "";

    if (!functionalAreaDetails.name) {
      updateErrorMessage("name", "Functional Area Title", "Enter ");
      errorSummary += "Enter functional area title \n";
    } else if (!utils.isValidCharacters(functionalAreaDetails.name)) {
      updateErrorMessage(
        "name",
        "Functional area title",
        " has restricted characters"
      );
      errorSummary += "Functional area title has restricted characters \n";
    }

    if (!functionalAreaDetails.description) {
      updateErrorMessage(
        "description",
        "Functional Area Description",
        "Enter "
      );
      errorSummary += "Enter Functional Area description \n";
    } else if (!utils.isValidCharacters(functionalAreaDetails.description)) {
      updateErrorMessage(
        "description",
        "Functional Area Description",
        " has restricted characters"
      );
      errorSummary +=
        "Functional Area Description has restricted characters \n";
    }

    if (errorSummary !== "") {
      messageDispatch(
        setMessageHandler({ type: "error", message: errorSummary })
      );
    } else {
      const dataObj = functionalAreaDetails;

      const getUpdateFunctionalAreaResponse = (resObj) => {
        if (
          !resObj ||
          !resObj["isSuccess"] ||
          (resObj["validationErrors"] !== undefined &&
            resObj["validationErrors"]?.length > 0)
        ) {
          messageDispatch(
            setMessageHandler({
              type: "error",
              message:
                (resObj["message"] ? resObj["message"] : "") +
                (resObj["validationErrors"]?.length > 0
                  ? "\n" + resObj["validationErrors"]?.join("\n")
                  : ""),
            })
          );
          return;
        }
        messageDispatch(
          setMessageHandler({
            type: "success",
            message: "Functional Area updated successfully!",
          })
        );
        setTimeout(() => {
          cancelFunctionalAreaHandler();
        }, 2000);
      };

      if (functionalAreaEdit) {
        updateFunctionalArea(
          {
            url: "FunctionalAreas/" + dataObj["functionalAreaKey"],
            method: "PUT",
            body: dataObj,
          },
          getUpdateFunctionalAreaResponse
        );
      } else {
        delete dataObj["functionalAreaKey"];
        updateFunctionalArea(
          { url: "FunctionalAreas", body: dataObj },
          getUpdateFunctionalAreaResponse
        );
      }
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          overflow: "hidden",
          padding: "0px",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          <MessageDisplay />
          <InputText
            type="text"
            label="Functional Area Title"
            id={"functionalAreaDetails.name"}
            value={functionalAreaDetails.name}
            onChange={(e) => onChangeHandler(e, "name")}
            isRequired={true}
            isError={isValid["name"] !== ""}
            charLength={50}
          />

          <InputText
            type="text"
            label="Functional Area Description"
            id={"functionalAreaDetails.description"}
            value={functionalAreaDetails.description}
            onChange={(e) => onChangeHandler(e, "description")}
            isRequired={true}
            isError={isValid["description"] !== ""}
            charLength={50}
          />

          <StatusControl
            label="Active"
            isRequired={false}
            fieldName={"active"}
            active={functionalAreaDetails.active}
            updateStatusValue={updateFunctionalAreaDetailsValue}
          />
          <SaveCancel
            cancelCall={() => cancelFunctionalAreaHandler()}
            saveCall={() => validateFunctionalAreaDetails()}
          />
        </div>
      </Box>
    </>
  );
};
